import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row mt-20 mb-20" }
const _hoisted_2 = { class: "col span-6" }
const _hoisted_3 = { class: "row polling" }
const _hoisted_4 = { class: "col span-6" }
const _hoisted_5 = { class: "col" }
const _hoisted_6 = { class: "col span-6" }

import { useI18n } from '@shell/composables/useI18n';
import { useStore } from 'vuex';
import Banner from '@components/Banner/Banner.vue';
import Checkbox from '@components/Form/Checkbox/Checkbox.vue';
import SelectOrCreateAuthSecret from '@shell/components/form/SelectOrCreateAuthSecret';
import UnitInput from '@shell/components/form/UnitInput';
import HelmOpResourcesSection from '@shell/components/fleet/HelmOpResourcesSection.vue';
import { SOURCE_TYPE } from '@shell/config/product/fleet';


export default /*@__PURE__*/_defineComponent({
  __name: 'HelmOpAdvancedTab',
  props: {
  value: {
    type:     Object,
    required: true
  },
  mode: {
    type:     String,
    required: true
  },
  isView: {
    type:    Boolean,
    default: false
  },
  sourceType: {
    type:     String,
    required: true
  },
  tempCachedValues: {
    type:     Object,
    required: true
  },
  correctDriftEnabled: {
    type:     Boolean,
    required: true
  },
  pollingInterval: {
    type:     Number,
    required: false,
    default:  undefined
  },
  isPollingEnabled: {
    type:     Boolean,
    required: true
  },
  showPollingIntervalMinValueWarning: {
    type:     Boolean,
    required: true
  },
  enablePollingTooltip: {
    type:    String,
    default: null
  },
  isNullOrStaticVersion: {
    type:     Boolean,
    required: true
  },
  downstreamSecretsList: {
    type:     Array,
    required: true
  },
  downstreamConfigMapsList: {
    type:     Array,
    required: true
  },
  registerBeforeHook: {
    type:     Function,
    required: true
  }
},
  emits: [
  'update:auth',
  'update:cached-auth',
  'update:correct-drift',
  'update:downstream-resources',
  'toggle-polling',
  'update:polling-interval',
  'update:validate-polling-interval',
],
  setup(__props, { emit: __emit }) {



const emit = __emit;

const store = useStore();
const { t } = useI18n(store);

const updateAuth = (value: string, key: string) => {
  emit('update:auth', { value, key });
};

const updateCachedAuthVal = (value: string, key: string) => {
  emit('update:cached-auth', { value, key });
};

const updateCorrectDrift = (value: boolean) => {
  emit('update:correct-drift', value);
};

const updateDownstreamResources = (event: { kind: string; list: string[] }) => {
  emit('update:downstream-resources', event);
};

const togglePolling = (value: boolean) => {
  emit('toggle-polling', value);
};

const updatePollingInterval = (value: number) => {
  emit('update:polling-interval', value);
};

const validatePollingInterval = () => {
  emit('update:validate-polling-interval');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (!__props.isView)
      ? (_openBlock(), _createBlock(Banner, {
          key: 0,
          color: "info",
          "label-key": "fleet.helmOp.add.steps.advanced.info",
          "data-testid": "helmOp-advanced-info"
        }))
      : _createCommentVNode("", true),
    _cache[6] || (_cache[6] = _createTextVNode()),
    _createElementVNode("h2", null, _toDisplayString(_unref(t)('fleet.helmOp.auth.title')), 1),
    _cache[7] || (_cache[7] = _createTextVNode()),
    _createVNode(_unref(SelectOrCreateAuthSecret), {
      value: __props.value.spec.helmSecretName,
      "register-before-hook": __props.registerBeforeHook,
      namespace: __props.value.metadata.namespace,
      "delegate-create-to-parent": true,
      "in-store": "management",
      mode: __props.mode,
      "generate-name": "helmrepo-auth-",
      "label-key": "fleet.helmOp.auth.helm",
      "pre-select": __props.tempCachedValues.helmSecretName,
      "cache-secrets": true,
      "show-ssh-known-hosts": true,
      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (updateAuth($event, 'helmSecretName'))),
      onInputauthval: _cache[1] || (_cache[1] = ($event: any) => (updateCachedAuthVal($event, 'helmSecretName')))
    }, null, 8, ["value", "register-before-hook", "namespace", "mode", "pre-select"]),
    _cache[8] || (_cache[8] = _createTextVNode()),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(Checkbox, {
          value: __props.value.spec.insecureSkipTLSVerify,
          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((__props.value.spec.insecureSkipTLSVerify) = $event)),
          type: "checkbox",
          "label-key": "fleet.helmOp.tls.insecure",
          mode: __props.mode
        }, null, 8, ["value", "mode"])
      ])
    ]),
    _cache[9] || (_cache[9] = _createTextVNode()),
    _createElementVNode("h2", null, _toDisplayString(_unref(t)('fleet.helmOp.resources.label')), 1),
    _cache[10] || (_cache[10] = _createTextVNode()),
    _createVNode(HelmOpResourcesSection, {
      value: __props.value,
      mode: __props.mode,
      "correct-drift-enabled": __props.correctDriftEnabled,
      "downstream-secrets-list": __props.downstreamSecretsList,
      "downstream-config-maps-list": __props.downstreamConfigMapsList,
      class: "mb-30",
      "onUpdate:correctDrift": updateCorrectDrift,
      "onUpdate:downstreamResources": updateDownstreamResources
    }, null, 8, ["value", "mode", "correct-drift-enabled", "downstream-secrets-list", "downstream-config-maps-list"]),
    _cache[11] || (_cache[11] = _createTextVNode()),
    (__props.sourceType === _unref(SOURCE_TYPE).REPO)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("h2", null, _toDisplayString(_unref(t)('fleet.helmOp.polling.label')), 1),
          _cache[5] || (_cache[5] = _createTextVNode()),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(Checkbox, {
                value: __props.isPollingEnabled,
                type: "checkbox",
                "label-key": "fleet.helmOp.polling.enable",
                "data-testid": "helmOp-enablePolling-checkbox",
                tooltip: __props.enablePollingTooltip,
                mode: __props.mode,
                disabled: __props.isNullOrStaticVersion,
                "onUpdate:value": togglePolling
              }, null, 8, ["value", "tooltip", "mode", "disabled"])
            ]),
            _cache[4] || (_cache[4] = _createTextVNode()),
            (__props.isPollingEnabled)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", _hoisted_5, [
                    (__props.showPollingIntervalMinValueWarning)
                      ? (_openBlock(), _createBlock(Banner, {
                          key: 0,
                          color: "warning",
                          "label-key": "fleet.helmOp.polling.pollingInterval.minimumValueWarning",
                          "data-testid": "helmOp-pollingInterval-minimumValueWarning"
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _cache[3] || (_cache[3] = _createTextVNode()),
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_unref(UnitInput), {
                      value: __props.pollingInterval,
                      min: "1",
                      "data-testid": "helmOp-pollingInterval-input",
                      suffix: _unref(t)('suffix.seconds', { count: __props.pollingInterval }),
                      label: _unref(t)('fleet.helmOp.polling.pollingInterval.label'),
                      mode: __props.mode,
                      "tooltip-key": "fleet.helmOp.polling.pollingInterval.tooltip",
                      "onUpdate:value": updatePollingInterval,
                      onBlurCapture: validatePollingInterval
                    }, null, 8, ["value", "suffix", "label", "mode"])
                  ])
                ], 64))
              : _createCommentVNode("", true)
          ])
        ], 64))
      : _createCommentVNode("", true)
  ]))
}
}

})